"use client";
import React, { useState, useEffect } from "react";
import Lottie from "lottie-react";
import animation from "../../assets/json/chat.json";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";

export default function ChatStart() {
  const profile = useSelector((state) => state.auth?.profile);
  const location = useLocation();
  const [siteWidth, setSiteWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setSiteWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const pathname = location.pathname;

  return (
    <>
      {/* {profile &&
        pathname !== "/chat" &&
        !pathname?.includes("/chat-china") &&
        !pathname?.includes("/account/order/") &&
        !pathname?.includes("/support/") && (
          <div
            className="aiFloat"
            style={{
              position: "fixed",
              bottom: 64,
              right: 64,
              zIndex: 1000,
            }}
          >
            <Link
              to={`/chat`}
              style={{
                width: siteWidth > 768 ? 70 : 60,
                height: siteWidth > 768 ? 70 : 60,
                background: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
                boxShadow: "0 0 10px rgba(0, 0, 0, 0.15)",
                border: "1px solid #f1f1f1",
              }}
            >
              <Lottie
                animationData={animation}
                loop={true}
                style={{
                  width: 100,
                  height: 100,
                }}
              />
            </Link>
          </div>
        )} */}
    </>
  );
}
